import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

import { Lightbox } from "react-modal-image"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeRequiredimgins extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  required_img_ins_id: "",
                  required_img_ins_name: "",
                  selectedFieldinsurance: "",
                  selectedTimeanswer_complaints: "",
                  selectedCustomer_satisfaction: "",
                  selectedNum_branchesdamages: "",

                  required_img_ins_desc: "",
                  required_img_ins_sample: "",
                  required_tum_img_ins_sample: "",
                  orderBy: "required_img_ins_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newRequiredimgins: true,
                  picturesRequestReady: "",
                  loading: false,
                  percent: 0,
                  optionFieldinsurance: [],
                  required_img_ins_force: "0",

                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
                  openDialog: false,
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      handleChangeRequiredimginsName = (event) => {
            this.setState({ required_img_ins_name: event.target.value })
      }

      onSelectPicRequest = (picture) => {
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }

      handleChangeRequiredimginsDesc = (event) => {
            this.setState({ required_img_ins_desc: event.target.value })
      }

      handleLevelof_prosperity = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance }, () => {
                  this.filterManagDiscount()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ required_img_ins_force: "1" })
            } else {
                  this.setState({ required_img_ins_force: "0" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        required_img_ins_id: row2.required_img_ins_id,
                        required_img_ins_name: row2.required_img_ins_name,
                        selectedFieldinsurance: { value: row2.required_img_fieldinsurance, label: row2.fieldinsurance_fa },
                        required_img_ins_desc: row2.required_img_ins_desc,
                        required_img_ins_sample: row2.required_img_ins_sample,
                        required_tum_img_ins_sample: row2.required_tum_img_ins_sample,
                        required_img_ins_force: row2.required_img_ins_force,
                        newRequiredimgins: false,
                  },
                  () => {}
            )
      }

      newRequiredimgins = (event) => {
            this.setState(
                  {
                        required_img_ins_id: "",
                        required_img_ins_name: "",
                        //  selectedFieldinsurance:optionFieldinsurance[0],
                        required_img_ins_force: "0",
                        required_img_ins_desc: "",
                        required_img_ins_sample: "",
                        required_tum_img_ins_sample: "",
                        newRequiredimgins: true,
                  },
                  () => {}
            )
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getRequiredimgins()
                                    self.getoptionFieldinsurance()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].fieldinsurance, label: arr.data[k].fieldinsurance_fa })
                              }
                              self.setState({ optionFieldinsurance: Company, selectedFieldinsurance: Company[0] }, () => {
                                    self.filterManagDiscount()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }

      getRequiredimgins() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterManagDiscount()
                                    self.newRequiredimgins()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_requiredimgins")

            xhttp.open("POST", `${constants.BASE_URL}/requiredimgins`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewRequiredimgins = (imageCode) => {
            const { required_img_ins_id, required_img_ins_name, selectedFieldinsurance, required_img_ins_desc, required_img_ins_force } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getRequiredimgins()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_requiredimgins")
            fd.append("required_img_ins_name", required_img_ins_name)
            fd.append("required_img_fieldinsurance", selectedFieldinsurance.value)
            fd.append("required_img_ins_desc", required_img_ins_desc)
            fd.append("required_img_ins_sample", imageCode)
            fd.append("required_img_ins_force", required_img_ins_force)
            xhttp.open("POST", `${constants.BASE_URL}/requiredimgins`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeRequiredimgins = (imageCode) => {
            const { required_img_ins_id, required_img_ins_name, selectedFieldinsurance, required_img_ins_desc, required_img_ins_force } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getRequiredimgins()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_requiredimgins")
            fd.append("required_img_ins_id", required_img_ins_id)
            fd.append("required_img_ins_name", required_img_ins_name)
            fd.append("required_img_fieldinsurance", selectedFieldinsurance.value)
            fd.append("required_img_ins_desc", required_img_ins_desc)
            fd.append("required_img_ins_force", required_img_ins_force)
            if (imageCode !== "") {
                  fd.append("required_img_ins_sample", imageCode)
            }

            xhttp.open("POST", `${constants.BASE_URL}/requiredimgins`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteImageRequire = () => {
            const { required_img_ins_id } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getRequiredimgins()
                              self.newRequiredimgins()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_requiredimgins")
            fd.append("required_img_ins_id", required_img_ins_id)

            xhttp.open("POST", `${constants.BASE_URL}/requiredimgins`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      uploadPicDelivery = (mode) => {
            const { picturesRequestReady, required_img_ins_name, selectedFieldinsurance, required_img_ins_desc } = this.state
            if (required_img_ins_desc != "" && required_img_ins_name != "" && selectedFieldinsurance != "") {
                  if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          if (mode === "new") {
                                                self.saveNewRequiredimgins(arr.data["image_code"])
                                          } else {
                                                self.changeRequiredimgins(arr.data["image_code"])
                                          }
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", picturesRequestReady)
                        fd.append("image_name", " تصویر عکس مورد نیاز" + required_img_ins_name)
                        fd.append("image_desc", "تصویر عکس مورد نیاز " + required_img_ins_name)
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        console.log(mode)
                        if (mode === "new") {
                              this.saveNewRequiredimgins("")
                        } else {
                              this.changeRequiredimgins("")
                        }
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      filterManagDiscount = () => {
            const { selectedFieldinsurance, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (temparray[i].required_img_fieldinsurance === selectedFieldinsurance.value) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  urlToHugeImageFile,
                  required_img_ins_force,
                  descImageFile,
                  urlToLargeImageFile,
                  optionFieldinsurance,
                  selectedFieldinsurance,
                  loading,
                  percent,
                  selectedNum_branchesdamages,
                  selectedCustomer_satisfaction,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newRequiredimgins,
                  required_img_ins_id,
                  required_img_ins_name,
                  required_img_ins_sample,
                  required_tum_img_ins_sample,
                  required_img_ins_desc,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی عکس" + required_img_ins_id}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt=""
                                                                              className={classes.large}
                                                                              src={required_tum_img_ins_sample}
                                                                              onClick={() => {
                                                                                    this.setImageModel(
                                                                                          required_tum_img_ins_sample,
                                                                                          required_img_ins_sample,
                                                                                          required_img_ins_name
                                                                                    )
                                                                              }}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام عکس"
                                                                        handleInputt={this.handleChangeRequiredimginsName}
                                                                        value={required_img_ins_name}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">{"رشته بیمه"} </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFieldinsurance}
                                                                              onChange={this.handleLevelof_prosperity}
                                                                              options={optionFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={required_img_ins_force === "1" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="اجباری بودن عکس"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات عکس"
                                                                        handleInputt={this.handleChangeRequiredimginsDesc}
                                                                        value={required_img_ins_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="عکس را انتخاب نمایید"
                                                                        onChange={this.onSelectPicRequest}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  {loading && <LinearProgress variant="determinate" value={percent} />}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newRequiredimgins ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.uploadPicDelivery("new")
                                                                              }}
                                                                        >
                                                                              {"ثبت عکس جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newRequiredimgins}
                                                                              >
                                                                                    {"عکس جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("modify")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>

                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {"حذف عکس مورد نیاز "}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell></TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "fieldinsurance_fa" ? order : false}
                                                                              >
                                                                                    {"نام رشته"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_fa"}
                                                                                          direction={orderBy === "fieldinsurance_fa" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"required_img_ins_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام عکس"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "required_img_ins_name"}
                                                                                          direction={
                                                                                                orderBy === "required_img_ins_name" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("required_img_ins_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"required_img_ins_desc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" توضیحات عکس"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "required_img_ins_desc"}
                                                                                          direction={
                                                                                                orderBy === "required_img_ins_desc" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("required_img_ins_desc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"required_img_ins_force"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"اجباری بودن عکس"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "required_img_ins_force"}
                                                                                          direction={
                                                                                                orderBy === "required_img_ins_force" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("required_img_ins_force")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["required_img_ins_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt=""
                                                                                                            src={row["required_tum_img_ins_sample"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                      {row["fieldinsurance_fa"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"required_img_ins_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["required_img_ins_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"required_img_ins_desc"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["required_img_ins_desc"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"required_img_ins_force"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["required_img_ins_force"] === "0" ||
                                                                                                      row["required_img_ins_force"] === 0 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}

                              {this.state.openImageBox && (
                                    <Lightbox
                                          medium={urlToLargeImageFile}
                                          large={urlToHugeImageFile}
                                          alt={descImageFile}
                                          onClose={this.closeLightbox}
                                          showRotate={true}
                                          hideZoom={false}
                                    />
                              )}

                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید عکس مورد نیاز را پاک نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteImageRequire} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeRequiredimgins)
